import { Buffer } from 'buffer'
import { EventEmitter } from 'events'

/**
 * Node.js polyfills for browser environment
 *
 * Required by Solana wallet libraries and Socket.IO that depend on Node.js built-ins
 */
export default defineNuxtPlugin(() => {
  if (typeof window !== 'undefined') {
    // Buffer polyfill
    window.Buffer = Buffer

    // EventEmitter polyfill - make it available globally
    // Some libraries expect `import EventEmitter from 'events'`
    // @ts-expect-error - Adding EventEmitter to window for compatibility
    window.EventEmitter = EventEmitter
  }
})
